import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'

import router from '@/router'

import Cookies from 'js-cookie';

// 基础配置
import base from '@/utils/base';

// 富文本编辑组件
import Editor from "@/components/Editor.vue";

import mavonEditor from 'mavon-editor'

import 'mavon-editor/dist/css/index.css'
import VueAnimateNumber from 'vue-animate-number'

import { VueJsonp } from 'vue-jsonp'






import {Badge,Cascader,Alert,Checkbox,Link,Switch,Popconfirm,InputNumber,TabPane,Tabs,TimePicker,Message,Image,MessageBox,DropdownMenu, Avatar, Dropdown, Icon, DropdownItem, Notification, DescriptionsItem, Descriptions, Loading, Col, DatePicker, Radio, RadioGroup, Button, Menu, Submenu, MenuItemGroup, MenuItem,  Dialog, Form, Input, FormItem, Select, Option, Breadcrumb, BreadcrumbItem, Upload, Table, TableColumn, Tag, Pagination } from 'element-ui';



Vue.component('el-cascader',Cascader)
Vue.component('el-link',Link)
Vue.component('el-button', Button)
Vue.component('el-dropdown-menu', DropdownMenu)
Vue.component('el-menu', Menu)
Vue.component('el-submenu', Submenu)
Vue.component('el-menu-item-group', MenuItemGroup)
Vue.component('el-menu-item', MenuItem)
Vue.component('el-dialog', Dialog)
Vue.component('el-form', Form)
Vue.component('el-input', Input)
Vue.component('el-form-item', FormItem)
Vue.component('el-select', Select)
Vue.component('el-option', Option)
Vue.component('el-breadcrumb', Breadcrumb)
Vue.component('el-breadcrumb-item', BreadcrumbItem)
Vue.component('el-upload', Upload)
Vue.component('el-table', Table)
Vue.component('el-table-column', TableColumn)
Vue.component('el-tag', Tag)
Vue.component('el-pagination', Pagination)
Vue.component('el-radio-group', RadioGroup)
Vue.component('el-radio', Radio)
Vue.component('el-date-picker', DatePicker)
Vue.component('el-col', Col)
Vue.component('el-descriptions', Descriptions)
Vue.component('el-descriptions-item', DescriptionsItem)
Vue.component('el-icon', Icon)
Vue.component('el-dropdown-item', DropdownItem)
Vue.component('el-dropdown', Dropdown)
Vue.component('el-avatar', Avatar)
Vue.component('el-image',Image)
Vue.component('el-time-picker',TimePicker)
Vue.component('el-tabs',Tabs)
Vue.component('el-tab-pane',TabPane)
Vue.component('el-input-number',InputNumber)
Vue.component('el-popconfirm',Popconfirm)
Vue.component('el-switch',Switch)
Vue.component('el-badge',Badge)
Vue.component('el-alert',Alert)
Vue.component('el-checkbox',Checkbox)
Vue.component('editor', Editor)

// vuex
import store from '@/store/index'

import socket from '@/utils/websocket';


Vue.config.productionTip = false

//应用插件
Vue.use(VueRouter)
Vue.use(mavonEditor)
Vue.use(Loading)
Vue.use(VueAnimateNumber)
Vue.use(VueJsonp)



new Vue({
  el: '#app',
  render: h => h(App),
  router,
  //安装全局事件总线
  beforeCreate() {
    Vue.prototype.$store = store
    Vue.prototype.$bus = this
    Vue.prototype.$base = base.get()
    Vue.prototype.$mm=MessageBox
    Vue.prototype.$msg=Message
    Vue.prototype.$alter = MessageBox.alert
    Vue.prototype.$message=Message
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.prototype.$loading = Loading.service
    Vue.prototype.$loading=Loading.service
    Vue.prototype.$notify = Notification
    Vue.prototype.$cookies=Cookies
    Vue.prototype.sendMsg = socket.sendMsg
  }
})
